import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AccountState } from 'src/app/core';
import { BrandsState, brandUuid } from 'src/app/core/store/brands';

import { ShowOxioAdminDirective } from './show-oxio-admin.directive';

@Directive({
  selector: '[appOxioAdminAsBrand]',
})
export class ShowOxioAdminAsBrandDirective extends ShowOxioAdminDirective implements OnInit {
  condition: boolean;
  @Input() set appOxioAdminAsBrand(condition: boolean) {
    this.condition = condition;
  }

  constructor(
    protected templateRef: TemplateRef<any>,
    protected viewContainer: ViewContainerRef,
    private storeBrand: Store<BrandsState>,
    private storeAdmin: Store<AccountState>,
  ) {
    super(templateRef, viewContainer, storeAdmin);
  }

  ngOnInit() {
    this.checkForOxioAdminAsBrand();
  }

  checkIsAdmin() {
    super.checkIsAdmin();
  }

  checkForOxioAdminAsBrand() {
    this.checkIsAdmin();
    this.storeBrand.pipe(select(brandUuid)).subscribe((brandUuid) => {
      if (
        (brandUuid !== undefined && this.condition && this.isAdmin) ||
        (!brandUuid && !this.condition && !this.isAdmin)
      ) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
